// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1hruV","buttons":"Footer_buttons__3e60R"};